var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/array.js
// module id = 404
// module chunks = 0